<template>
    <div class="container mx-auto">
        <div class="bg-white p-8 flex flex-col justify-center items-center">
            <section class="md:w-[80%]">
                <div class="">
                    <h1 class="text-[28px] font-semibold text-left text-gray-800 mb-6">
                        Frequently Asked Questions
                    </h1>
                    <div v-for="(faq, index) in faqs" :key="index">
                        <div class="mt-3 space-y-2">
                            <div class="border-2 border-gray-100 rounded-[5px]">
                                <button
                                    class="flex items-center justify-between w-full p-4 bg-gray-50"
                                >
                                    <h1
                                        class="font-semibold text-gray-700"
                                        @click="showDetails(index)"
                                    >
                                        {{ faq.question }}
                                    </h1>

                                    <span
                                        class="text-gray-400 bg-[#F6F6F6] p-2 rounded-[4px]"
                                        v-if="isCollapse === index"
                                        @click="showPreviesDetails(index)"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="14.001"
                                            height="7.173"
                                            viewBox="0 0 14.001 7.173"
                                        >
                                            <path
                                                id="angle-small-down_4_"
                                                data-name="angle-small-down (4)"
                                                d="M18.71,8.21a1,1,0,0,0-1.42,0l-4.58,4.58a1,1,0,0,1-1.42,0L6.71,8.21A1,1,0,0,0,5.29,9.62l4.59,4.59a3,3,0,0,0,4.24,0l4.59-4.59A1,1,0,0,0,18.71,8.21Z"
                                                transform="translate(19.001 15.087) rotate(180)"
                                            />
                                        </svg>
                                    </span>
                                    <span
                                        class="text-white bg-[#F6F6F6] p-2 rounded-[4px]"
                                        v-else
                                        @click="showDetails(index)"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="14.001"
                                            height="7.173"
                                            viewBox="0 0 14.001 7.173"
                                        >
                                            <path
                                                id="angle-small-down_4_"
                                                data-name="angle-small-down (4)"
                                                d="M18.71,8.21a1,1,0,0,0-1.42,0l-4.58,4.58a1,1,0,0,1-1.42,0L6.71,8.21A1,1,0,0,0,5.29,9.62l4.59,4.59a3,3,0,0,0,4.24,0l4.59-4.59A1,1,0,0,0,18.71,8.21Z"
                                                transform="translate(-4.999 -7.914)"
                                            />
                                        </svg>
                                    </span>
                                </button>
                                <!--  class="whitespace-pre" -->
                                <div :class="[isCollapse === index ? '' : 'hidden']">
                                    <hr class="border-gray-100" />
                                    <p class="p-6 text-sm text-black text-opacity-60">
                                        {{ faq.answer }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div class="flex justify-center my-[30px] text-[24px] opacity-50">Or</div>
            <div class="flex md:justify-center md:gap-6 justify-around gap-2 cursor-pointer">
                <div
                    class="flex justify-center items-center gap-2 bg-[#EAF5F6] rounded-[14px] h-[55px] md:w-[170px] w-[150px]"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22.541"
                        height="22.54"
                        viewBox="0 0 22.541 22.54"
                    >
                        <g
                            id="_01_align_center"
                            data-name="01 align center"
                            transform="translate(0.007 -0.021)"
                        >
                            <path
                                id="Path_26716"
                                data-name="Path 26716"
                                d="M1.356,6.265A1.879,1.879,0,0,0,.543,9.4l3.2,3.2v6.186H9.941l3.227,3.222a1.866,1.866,0,0,0,1.323.552,1.911,1.911,0,0,0,.479-.062A1.858,1.858,0,0,0,16.3,21.2L22.534.021Zm.522,1.806L17.873,3.356,5.629,15.581V11.823ZM14.5,20.681,10.72,16.909H6.963L19.2,4.677Z"
                                transform="translate(0)"
                            />
                        </g>
                    </svg>
                    <p class="text-[14px] font-bold">
                        <a href="mailto: leads@dkilo.com">Contact Sales</a>
                    </p>
                </div>
                <div
                    class="flex justify-center items-center gap-2 bg-[#EAF5F6] rounded-[14px] h-[55px] p-6"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22.541"
                        height="22.54"
                        viewBox="0 0 22.541 22.54"
                    >
                        <g
                            id="_01_align_center"
                            data-name="01 align center"
                            transform="translate(0.007 -0.021)"
                        >
                            <path
                                id="Path_26716"
                                data-name="Path 26716"
                                d="M1.356,6.265A1.879,1.879,0,0,0,.543,9.4l3.2,3.2v6.186H9.941l3.227,3.222a1.866,1.866,0,0,0,1.323.552,1.911,1.911,0,0,0,.479-.062A1.858,1.858,0,0,0,16.3,21.2L22.534.021Zm.522,1.806L17.873,3.356,5.629,15.581V11.823ZM14.5,20.681,10.72,16.909H6.963L19.2,4.677Z"
                                transform="translate(0)"
                            />
                        </g>
                    </svg>
                    <p class="text-[14px] font-bold">
                        <a href="mailto: support@dkilo.com">Contact Support</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            data: [
                {
                    title: "Tutorial",
                    details: "Play a video for quick start",
                },

                {
                    title: "hello@dkilo.com",
                    details: "technical questions and problems",
                },
                {
                    title: "Help Center",
                    details: "Coming soon",
                },
            ],
            isCollapse: 0,
            faqs: [
                {
                    question: "What is\n dKilo?",
                    answer: `dKilo is a street-level digital out-of-home advertising platform. We display dynamic ads on moving vehicles. When the vehicles move, the ads move with them. We compensate vehicle owners with weekly
payments as long as they’re moving around cities while the ads are displayed. For businesses and companies, we provide accurate and real-time performance reports, metrics, full control of campaigns,
and business intelligence insights related to the ads published through dKilo.`,
                },
                {
                    question: "Are you an Advertising Agency?",
                    answer: "dKilo identifies as an AdTech Company. Advertising Technologies are an important part of running a superior digital advertising campaign. Advertisers use many types of tech to gain an edge over their competitors.",
                },
                {
                    question: "What is pDOOH?",
                    answer: `pDooh refers to Programmatic Digital Out of Home. Programmatic refers to the automated buying and selling of media based on data-driven decisions. Programmatic Digital OOH offers access to vibrant digital
screens that are remotely connected to the internet and equips certain sensors so that the content on such screens could change on demand and provide metrics and valuable data back to the advertisers.`,
                },
                {
                    question: "How do I know that my ads are running?",
                    answer: `dkilo's dashboard enables you to see where your instant ads are displayed and the locations of vehicles through a real-time heat map that is updated in real-time as well as important information regarding
your running campaigns.`,
                },
                {
                    question: "What is an impression?",
                    answer: `An impression is a metric used to quantify the number of digital views or engagements of a piece of content, usually an advertisement, digital post, or web page. Impressions are also referred to as an 'ad view.'
They are used in online advertising, which often pays on a per-impression basis. Digital Out-of-home (DOOH) impressions reflect the number of times the ad had been exposed to people.`,
                },
                {
                    question: "What is an Ad Loop?",
                    answer: `An Ad Loop is a certain amount of time when your content was displayed on a digital screen. Ad loops time differs from one platform to another. (for example its 6 seconds by default on YouTube)
dKilo uses an ad loop of 30 seconds to display the ads on its screens, so if you start a campaign with 20,000 ad loops, your content had been displayed 20 thousand times and each time was 30 seconds long.`,
                },
                {
                    question: "How do you calculate impressions?",
                    answer: `dKilo uses a special technology that allows us to measure population density in real-time and then refine the data using a special AI algorithm to refine the results leading to accurate reporting of actual people
exposed to the DOOH ads published on dKilo digital screens.`,
                },
                {
                    question: "How can I target specific Locations with my Ads?",

                    answer: `Adding a location 
Click "Add"
Click and drag the marker to change the target location.
Click and drag the edges of the marker to resize the target area.
Removing a location
Right-click on a marker
Click "OK" to confirm
                            `,
                },
                {
                    question: "How can I add a new campaign?",
                    answer: `Click Campaign in the navigation
Click Create new Button Fill in Your Campaign info:
Campaign name and Company name
then Choose Your target From this Campaign.
Click Next

Adding a location
Click "Add"
Click and drag the marker to change the target location.
Click and drag the edges of the marker to resize the target area.
Removing a location

Right-click on a marker
Click "OK" to confirm

Set your Budget
Set your Campaign Duration
Click Next
`,
                },
                {
                    question: "Can I change the content of my ads?",
                    answer: `Yes! Absolutely
Create a new campaign and upload your new media by uploading your designs from your computer Or if you’re feeling creative feel free to design a new piece of content using the Canva button.
Press Submit
Our team will review the updated content and will approve it if it complies with the advertising policies.
`,
                },
                {
                    question: "How can I reset my publisher password?",
                    answer: `Click your profile icon on the upper right corner of the publisher dashboard, then Click Profile, Choose your new Password and Confirm the new password Then Click Save Changes.
`,
                },
            ],
            answer: [],
        };
    },
    computed: {
        // parsedBody() {
        //     for (let i = 0; i < this.faqs.length; i++) {
        //         let element = this.faqs[i].question;
        //         return element;
        //     }
        // },
    },
    mounted() {
        //Change Document Title
        document.title = "dKilo Ad Manager - Support";
        // this.parsedBody();
    },
    methods: {
        // parsedBody() {
        //     for (let i = 0; i < this.faqs.length; i++) {
        //         this.answer.push(this.faqs[i].question);
        //     }
        //     console.log("lll");
        //     console.log(this.answer[0].replace(/\n/g, "<br/>"));

        //     // this.answer = element;
        // },
        showDetails(index) {
            this.isCollapse = index;
        },
        showPreviesDetails(index) {
            this.isCollapse = index - 1;
        },
    },
};
</script>

<style></style>
